import React from "react";
import TextInput from "@elements/fields/textInput";

interface Props {
    value: string;
    placeholder?: string;
    onChange: (value: string) => void;
}

const QuestionTextInput: React.FC<Props> = ({ value, placeholder, onChange }) => {
    return (
        <TextInput
            name="gift-finder-text"
            placeholder={placeholder}
            value={value}
            onChange={(event) => onChange(event.target.value)}
            className="[&_input]:bg-white"
        />
    );
};

export default React.memo(QuestionTextInput);
